import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import OktaSignInWidget from "../../components/Widgets/OktaSignInWidget";
import { useOktaAuth } from "@okta/okta-react";
import LogCapture from "../../utils/LogManagement/LogHelper";
import { clear, removeItem } from "../../utils/StorageHelpers";
import UserContext from "../../lib/UserContext";
import { fetchLoggedUser } from "../../utils/UserHelper";
import { getToken } from "../../utils/OktaHelpers";
import { setObject } from "../../utils/StorageHelpers";
import { loginMessageService } from "../../utils/Observer/ObserverService";

export default function Login() {
    const { oktaAuth, authState } = useOktaAuth();
    const [user, setUser] = useState(null);

    const initFirebase = useContext(UserContext).initFirebase;

    useEffect(() => {
        if (!authState?.isAuthenticated) {
            clear(true);
            removeItem("user");
        } else {
            if (!user && getToken()) {
                fetchLoggedUser(setUser).then(() => {
                    //Send message that user obj have been saved
                    loginMessageService.send(true);
                });
            }
        }
    }, [authState]);

    const onSuccess = async (tokens) => {
        setObject("okta-token-storage", tokens);
        fetchLoggedUser(setUser).then(() => {
            //Send message that login is successfull and user obj have been saved
            loginMessageService.send(true);
            oktaAuth.handleLoginRedirect(tokens).then(() => {
                const email = tokens?.accessToken?.claims?.email || "unknown";
                LogCapture.info(`${email} logged in to the portal`);
                initFirebase(email);
            });
        });
    };

    const onError = (err) => {
        try {
            LogCapture.error(`User was unable to login with error: ${err}`);
        } catch (error) {
            LogCapture.error("Error while logging in");
        }
    };

    const renderHomePage = () => {
        if (user) {
            return <Redirect to="/dashboard" />;
        }

        return null;
    };

    if (!authState) return null;
    return authState.isAuthenticated ? (
        renderHomePage()
    ) : (
        <div className="mx-auto px-4 py-8 h-full">
            <div className="flex content-center items-center justify-center h-full">
                <OktaSignInWidget onSuccess={onSuccess} onError={onError} />
            </div>
        </div>
    );
}
